/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ success: NonNullable<unknown>, failed: NonNullable<unknown> }} Measure_Reliability_AriaInputs */

const en_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.success} of calls succeeded, ${i?.failed} failed`)
};

const zh_hans1_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.success} 的调用成功，${i?.failed} 失败`)
};

const pt_br2_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.success} das chamadas tiveram sucesso, ${i?.failed} falharam`)
};

const es_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.success} de las llamadas tuvieron éxito, ${i?.failed} fallaron`)
};

const fr_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.success} des appels ont réussi, ${i?.failed} ont échoué`)
};

const de_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.success} der Aufrufe erfolgreich, ${i?.failed} fehlgeschlagen`)
};

const ru_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Успешно: ${i?.success}, неудачно: ${i?.failed}`)
};

const it_measure_reliability_aria = /** @type {(inputs: Measure_Reliability_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.success} delle chiamate riuscite, ${i?.failed} fallite`)
};

/**
* | output |
* | --- |
* | "{success} of calls succeeded, {failed} failed" |
*
* @param {Measure_Reliability_AriaInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_reliability_aria = /** @type {((inputs: Measure_Reliability_AriaInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Reliability_AriaInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_reliability_aria(inputs)
	if (locale === "pt-BR") return pt_br2_measure_reliability_aria(inputs)
	if (locale === "es") return es_measure_reliability_aria(inputs)
	if (locale === "fr") return fr_measure_reliability_aria(inputs)
	if (locale === "de") return de_measure_reliability_aria(inputs)
	if (locale === "ru") return ru_measure_reliability_aria(inputs)
	if (locale === "it") return it_measure_reliability_aria(inputs)
	return en_measure_reliability_aria(inputs)
});